import * as types from '../actions/types';

const initialState = {
    years: [],
    terms: [],
    candidatslist: [],
    options: {},
    loading: false,
    loading_options: false,
    amo: null,
    government: null,
    loading_listFile: false,
    chief: {},
    candidatInfo: null,
    loading_candidatInfo: false,
    task: null,
    excel_list: null,
    excel_list_loading: null,
    
    grant_types_loading: false,
    grant_types: [],

    scholarshipSettings: null,
    scholarshipSettingsLoading: false,

    scholarshipLevels: null,
    scholarshipLevelsLoading: false,
    
    scholarshipTree: null,
    scholarshipTreeLoading: false,
  
    scholarshipGrantsList: null,
    scholarshipGrantsListLoading: false,
};

export default function grants(state = initialState, action) {
    switch (action.type) {
        case types.GRANTS_YEARS:
            return {
                ...state,
                years: action.payload
            };
        case types.GRANTS_TERMS:
            return {
                ...state,
                terms: action.payload
            };
        case types.CANDIDATS_LIST:
            return {
                ...state,
                candidatslist: action.payload
            };
        case types.SET_CANDIDATS_LIST_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case types.GRANTS_OPTIONS:
            return {
                ...state,
                options: action.payload
            };
        case types.SET_GRANTS_OPTIONS_LOADING:
            return {
                ...state,
                loading_options: action.payload
            };
        case types.CANDIDATS_LIST_FILE:
            return {
                ...state,
                [action.payload.type]: action.payload.result, 
            };
        case types.SET_CANDIDATS_LIST_FILE_LOADING:
            return {
                ...state,
                loading_listFile: action.payload
            };
        case types.GRANTS_CHIEFS:
            return {
                ...state,
                chief: action.payload
            };
        case types.SET_CANDIDAT_INFO:
            return {
                ...state,
                candidatInfo: action.payload
            };
        case types.SET_CANDIDAT_INFO_LOADING:
            return {
                ...state,
                loading_candidatInfo: action.payload
            };
        case types.GRANTS_TASK:
            return {
                ...state,
                task: action.payload
            };
        case types.SET_EXCEL_LIST:
            return {
                ...state,
                excel_list: action.payload
            };
        case types.SET_EXCEL_LIST_LOADING:
            return {
                ...state,
                excel_list_loading: action.payload
            };
        case types.SET_GRANT_TYPES_LOADING:
            return {
                ...state,
                grant_types_loading: action.payload
            };
        case types.SET_GRANT_TYPES:
            return {
                ...state,
                grant_types: action.payload
            };
        case types.SET_SCHOLARSHIP_SETTINGS_LOADING:
            return {
                ...state,
                scholarshipSettingsLoading: action.payload
            };
        case types.SET_SCHOLARSHIP_SETTINGS:
            return {
                ...state,
                scholarshipSettings: action.payload
            };
        case types.SET_SCHOLARSHIP_LEVELS_LOADING:
            return {
                ...state,
                scholarshipLevelsLoading: action.payload
            };
        case types.SET_SCHOLARSHIP_LEVELS:
            return {
                ...state,
                scholarshipLevels: action.payload
            };
        case types.SET_SCHOLARSHIP_TREE_LOADING:
            return {
                ...state,
                scholarshipTreeLoading: action.payload
            };
        case types.SET_SCHOLARSHIP_TREE:
            return {
                ...state,
                scholarshipTree: action.payload
            };
        case types.SET_SCHOLARSHIP_GRANTS_LIST_LOADING:
            return {
                ...state,
                scholarshipGrantsListLoading: action.payload
            };
        case types.SET_SCHOLARSHIP_GRANTS_LIST:
        return {
                ...state,
                scholarshipGrantsList: action.payload
            };
        default:
            return state;
    }
}
